// extracted by mini-css-extract-plugin
export var chip = "_mc-0";
export var icon = "_mc-1";
export var remove = "_mc-2";
export var removeIcon = "_mc-3";